import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoDestinoMonto } from '../_models/producto-destino-monto';

@Injectable({
  providedIn: 'root'
})
export class ProductoDestinoMontoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosDestinosMontos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoDestinoMonto[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoDestinoMonto[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoDestinoMonto[] ) );
  }

  listadoPorProductoIndicadorAnalizamos( idProducto: string, indicadorAnalizamos: boolean ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto + '/indicadorAnalizamos/' + indicadorAnalizamos + '/enabled' ).pipe( map( res => res as ProductoDestinoMonto[] ) );
  }

  listadoPorProductoHabilitadoYDestinoYIndicadorAnalizamos( idProducto: string, idDestino: string, indicadorAnalizamos: boolean ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto + '/destino/' + idDestino + '/indicadorAnalizamos/' + indicadorAnalizamos  + '/enabled' ).pipe( map( res => res as ProductoDestinoMonto[] ) );
  }

  obtenerPorProductoYDestino(idProducto: string, idDestino: string){
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto + '/destino/' + idDestino + '/enabled' ).pipe( map( res => res as ProductoDestinoMonto[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoDestinoMonto ) );
  }

  crear( regCrear: ProductoDestinoMonto ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoDestinoMonto ) );
  }

  actualizar( regActualizar: ProductoDestinoMonto ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: ProductoDestinoMonto[] ) {
    regActualizar.map( ( s: ProductoDestinoMonto ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar ).pipe( map( res => res as any ) );
  }
}
